import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "24", "height": "24", "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M2.00049 1.99989C2.00032 8.66652 2.00024 15.3332 2 21.9998C8.66667 21.9998 15.3333 21.9999 22 21.9999V1.99996C15.3335 1.99935 8.667 2.00035 2.00049 1.99989Z", "stroke": "currentColor", "stroke-width": "2", "stroke-miterlimit": "16" } }), _c("path", { attrs: { "d": "M2 12H5.18262", "stroke": "currentColor", "stroke-width": "2", "stroke-linecap": "square" } }), _c("path", { attrs: { "d": "M18.7227 12H22", "stroke": "currentColor", "stroke-width": "2", "stroke-linecap": "square" } }), _c("path", { attrs: { "d": "M16 7.14014V16.7283", "stroke": "#4791FF", "stroke-width": "2", "stroke-linejoin": "bevel" } }), _c("path", { attrs: { "d": "M7 16.729C7 15.9108 10.2727 7.729 10.2727 7.729C10.2727 7.729 13.5455 15.9108 13.5455 16.729", "stroke": "#4791FF", "stroke-width": "2", "stroke-linejoin": "bevel" } }), _c("path", { attrs: { "d": "M8.5 14H12", "stroke": "#4791FF ", "stroke-width": "2", "stroke-linejoin": "bevel" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const AIIcon = __component__.exports;
export {
  AIIcon as default
};
